import { skillResourceLicenses } from "@/constants/skillResourceLicenses";
import { ResourceType } from "@/enums/ResourceType";
import { timeToGrowthMinutes } from "@/features/assignment_modal/utils";

export function getMostCommonGrade(students: { grade: string }[]): number | null {
  if (!students || students.length === 0) return null;

  const gradeCounts = new Map<string, number>();

  for (const student of students) {
    const grade = student.grade.toString();
    gradeCounts.set(grade, (gradeCounts.get(grade) || 0) + 1);
  }

  let mostCommonGrade: string | null = null;
  let highestCount = 0;

  gradeCounts.forEach((count, grade) => {
    if (count > highestCount) {
      highestCount = count;
      mostCommonGrade = grade;
    }
  });

  return mostCommonGrade;
}

export const getTimeAssignedByGrade = (
  resourceType: string,
  classGradeLevel: { grade: string }[]
) => {
  const tutorTypes = skillResourceLicenses.tutor;

  let timeAssigned = 0;

  const gradeNumber = getMostCommonGrade(classGradeLevel);
  if (gradeNumber === null) return 0;

  const grade = String(gradeNumber) as keyof typeof timeToGrowthMinutes;
  const gradeTimes = timeToGrowthMinutes[grade];

  if (!gradeTimes) return 0;

  if (tutorTypes.includes(resourceType as ResourceType)) {
    timeAssigned = gradeTimes.tutor;
  } else if (resourceType === ResourceType.istationLegacyActivity) {
    timeAssigned = gradeTimes.instruct?.istationLegacyActivity;
  } else if (resourceType === ResourceType.microLesson) {
    timeAssigned = gradeTimes.instruct?.microLesson;
  } else if (resourceType === ResourceType.teacherResource) {
    timeAssigned = gradeTimes.teacherResource;
  }

  return timeAssigned || 0;
};
